/**
 * DF card hover video
 *
 * Desktop : lance la vidéo d'une carte produit (.df-card-video) quand la souris survole l'image,
 * la met en pause et la remet au début quand la souris sort.
 * Mobile (écran tactile) : la vidéo est la 2e slide du carrousel de la carte ; elle se lance
 * dès qu'elle est visible à plus de 60 % et se remet en pause / au début quand on revient sur la 1re image.
 * La vidéo n'est téléchargée qu'au premier survol ou à la première arrivée sur la slide (preload="none").
 */
(function () {
  if (window.__dfCardVideoInit) return;
  window.__dfCardVideoInit = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isTouch = window.matchMedia('(pointer: coarse)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mediaOf(target) {
    return target && target.closest ? target.closest('.product-card__media') : null;
  }

  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches) return;
    var media = mediaOf(e.target);
    if (!media) return;
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    var video = media.querySelector('.df-card-video');
    if (!video) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  });

  document.addEventListener('mouseout', function (e) {
    var media = mediaOf(e.target);
    if (!media) return;
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    var video = media.querySelector('.df-card-video');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (err) {}
  });

  // Les événements média ne remontent pas : on les écoute en phase de capture.
  document.addEventListener('playing', function (e) {
    if (e.target.classList && e.target.classList.contains('df-card-video')) e.target.classList.add('is-playing');
  }, true);

  document.addEventListener('pause', function (e) {
    if (e.target.classList && e.target.classList.contains('df-card-video')) e.target.classList.remove('is-playing');
  }, true);

  // ---- Mobile : lecture automatique quand la slide vidéo est visible ----
  function setupTouchVideo(video) {
    if (video.__dfTouchInit) return;
    video.__dfTouchInit = true;

    var scroller = mediaOf(video);
    if (!scroller || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!isTouch.matches || reduceMotion.matches) return;

        if (entry.isIntersecting) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
          try { video.currentTime = 0; } catch (err) {}
        }
      });
    }, { root: scroller, threshold: 0.6 });

    observer.observe(video);
  }

  function scan() {
    if (!isTouch.matches) return;
    var videos = document.querySelectorAll('.df-card-video');
    for (var i = 0; i < videos.length; i++) setupTouchVideo(videos[i]);
  }

  var scanTimer = null;
  function scheduleScan() {
    if (scanTimer) return;
    scanTimer = setTimeout(function () { scanTimer = null; scan(); }, 150);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);

  // Cartes ajoutées après coup (filtres, pagination, chargement infini).
  if ('MutationObserver' in window) {
    new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
